# Following Vue component standards from rule 2000-vue-component
<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Contact Form') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-card outlined class="mb-4">
                <v-card-text class="d-flex align-center">
                  <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('Page Status') }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-switch
                    v-model="formData.pages.contact.active"
                    :label="
                      formData.pages.contact.active
                        ? $t('Active')
                        : $t('Inactive')
                    "
                    dense
                    hide-details
                    class="mt-0"
                    @change="updateForm"
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FormRulesMixin from 'components/mixins/form-rules-mixin'

export default {
  name: 'ContactFormPage',

  mixins: [FormRulesMixin],

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        name: this.bookingEngineSetting.name,
        pages: {
          contact: {
            active: this.bookingEngineSetting.pages?.contact?.active || false,
          },
        },
      },
    }
  },

  watch: {
    'formData.pages.contact.active': {
      handler() {
        this.updateForm()
      },
    },
    bookingEngineSetting: {
      handler(newVal) {
        this.formData = {
          name: newVal.name,
          pages: {
            contact: {
              active: newVal.pages?.contact?.active || false,
            },
          },
        }
      },
      deep: true,
    },
  },

  methods: {
    updateForm() {
      if (!this.$refs.form || this.$refs.form.validate()) {
        const updatedData = {
          ...this.bookingEngineSetting,
          pages: {
            ...this.bookingEngineSetting.pages,
            contact: {
              ...this.bookingEngineSetting.pages?.contact,
              ...this.formData.pages.contact,
            },
          },
        }
        this.$emit('update:setting', updatedData)
      }
    },
  },
}
</script>
